import React from "react";
import { useNavigate } from "react-router-dom";

import { ListItem } from "../../../../Ui";
import { ReactComponent as MapIcon } from "../../../../../assets/img/map.svg";
import { ReactComponent as PolyIcon } from "../../../../../assets/img/polygon.svg";

import { FarmPoints } from "components/Forms";

const LINKS = [
  { text: "Ajoutez un Champs", icon: <MapIcon />, goTo: "map" },
  // { text: "Ajoutez un polygone", icon: <PolyIcon />, goTo: "polygon" },
];

export default function Links({ onModalClose }) {
  const navigate = useNavigate();
  const [selected, setSelected] = React.useState("");

  React.useEffect(() => {
    if (selected === "polygon") {
      navigate("/farms/polygon");
      onModalClose();
    }

    if (selected === "map") {
      onModalClose();
    }
  }, [selected]);

  return (
    <div>
      {LINKS.map((map) => (
        <ListItem
          key={map.text}
          {...map}
          iconSize={20}
          className="p-6 mb-3"
          chevron={false}
          icon={map.icon}
          onClick={(cb) => {
            if (map.goTo !== "polygon") {
              setSelected(map.goTo);
              if (cb) {
                cb();
              }
            }
          }}
        />
      ))}

      <FarmPoints
        // {...props}
        visible={selected === "map"}
        onCancel={() => {
          setSelected("");
        }}
        onSuccess={() => {
          setSelected("");
        }}
      />
    </div>
  );
}
